import { render, staticRenderFns } from "./UserAvatarGroup.vue?vue&type=template&id=841619c8&"
import script from "./UserAvatarGroup.vue?vue&type=script&lang=js&"
export * from "./UserAvatarGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports